export const rotationsTypes = {
  SMART: 'smart',
  RANDOM: 'random'
}
